import { useFormik } from 'formik';
import { FormValues } from '../types/userDetailFormValues';
import { InputProps as StandardInputProps } from '@mui/material/Input/Input';
import React, { useEffect, useState } from 'react';
import { Fade } from '@mui/material';
import BorderedSection from '../../shared/borderedSection';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useProperties, ManagedProperty } from '../../../system/EntityManager';

interface InstallerState {
  properties: Partial<ManagedProperty>[];
  selectedPropertyIds: string[];
}

export function UserInstallerTab(props: {
  formik: ReturnType<typeof useFormik<FormValues>>;
  onChange: StandardInputProps['onChange'];
}) {
  const {
    formik,
    // TODO: Peter: if we don't need onChange as a prop, delete it.
    // onChange,
  } = props;
  const [installerState, setInstallerState] = useState<InstallerState>({
    properties: [],
    selectedPropertyIds: [],
  });
  const { properties } = useProperties();

  useEffect(() => {
    let selectedPropertyIds: string[] = [];
    if (properties?.length) {
      selectedPropertyIds = properties
        .filter((prop) => formik.values.installerProperties.includes(prop._id))
        .map((prop) => prop._id);
    }
    setInstallerState({ properties, selectedPropertyIds });
  }, [properties, formik]);

  return (
    <Fade in={true} style={{ transitionDuration: '1100ms' }}>
      <div
        style={{
          width: '100%',
        }}
      >
        <h2 style={{ margin: 0, marginBottom: '20px' }}>Installer Settings</h2>
        <div>
          <BorderedSection
            title="Installable properties for this user"
            error={!!formik.errors.installerProperties}
            hint={formik.errors.installerProperties || ''}
          >
            <FormGroup style={{ marginTop: '-6px', marginLeft: '6px' }}>
              {installerState.properties.length
                ? installerState.properties.map((property) => {
                    return property._id ? (
                      <FormControlLabel
                        key={property._id}
                        onChange={(e, checked) => {
                          e.preventDefault();
                          const newPropIds = checked
                            ? [
                                ...formik.values.installerProperties,
                                property._id,
                              ]
                            : formik.values.installerProperties.filter(
                                (id) => id !== property._id,
                              );
                          formik.setFieldValue(
                            'installerProperties',
                            newPropIds,
                          );
                        }}
                        control={
                          <Checkbox
                            id={property._id}
                            value={property._id}
                            checked={installerState.selectedPropertyIds.includes(
                              property._id,
                            )}
                          />
                        }
                        label={property.title || 'no title property'}
                      />
                    ) : null;
                  })
                : null}
            </FormGroup>
          </BorderedSection>
        </div>
      </div>
    </Fade>
  );
}
